import { coreApi } from "../../app/core-api";
import { EntityCreateResult, PagedResult, PagedSearchFilter } from "../../app/types";
import {
    PartialPayrollGenerateDto,
    PayRollAddHocItem,
    PayRollAddHocItemBulkCreate,
    PayRollAddHocItemListItem,
    PayrollAddHocItemsFilter,
    PayRollAddHocItemUpdate,
    PayrollFilter,
    PayrollGenerateDto,
    PayrollGenerateResultDto,
    PayrollListItem,
    PayslipEmailResult,
} from "./payroll.types";

export const payrollApi = {
    generate,
    generatePartial,
    search,
    disburse,
    searchPayrollAddHocItems,
    createPayrollAddHocItems,
    getPayrollAddHocItem,
    updatePayrollAddHocItem,
    deletePayrollAddHocItem,
    emailPayslips,
};

const controller = "payrolls";

function generate(data: PayrollGenerateDto) {
    return coreApi.post<PayrollGenerateResultDto>(`${controller}/generate`, data);
}

function generatePartial(data: PartialPayrollGenerateDto) {
    return coreApi.post<PayrollGenerateResultDto>(`${controller}/partial/generate`, data);
}

function search(filter: PayrollFilter) {
    return coreApi.get<PagedResult<PayrollListItem>>(controller, filter);
}

function disburse(id: string, disburse: boolean) {
    return coreApi.post(`${controller}/${id}/disburse?disbursed=${disburse}`, {});
}

function searchPayrollAddHocItems(filter: PagedSearchFilter<PayrollAddHocItemsFilter>) {
    return coreApi.get<PagedResult<PayRollAddHocItemListItem>>(`${controller}/addHocItems`, {
        ...filter.filter,
        ...filter.pagination,
    });
}

function createPayrollAddHocItems(data: PayRollAddHocItemBulkCreate) {
    return coreApi.post<EntityCreateResult>(`${controller}/addHocItems`, data);
}

function getPayrollAddHocItem(id: string) {
    return coreApi.get<PayRollAddHocItem>(`${controller}/addHocItems/${id}`);
}

function updatePayrollAddHocItem(id: string, data: PayRollAddHocItemUpdate) {
    return coreApi.put<PayRollAddHocItem>(`${controller}/addHocItems/${id}`, data);
}

function deletePayrollAddHocItem(id: string) {
    return coreApi.remove(`${controller}/addHocItems/${id}`);
}

function emailPayslips(id: string, employeeNos?: string) {
    return coreApi.post<PayslipEmailResult>(`${controller}/${id}/EmailPayslips?employeeNos=${employeeNos}`, {});
}
